import React, { useState } from 'react';
import logo from '../logo.png';

const Nav = () => {
  const [opened, setOpened] = useState(true);

  return (
    <header className='w-100'>
      <div className='container'>
        <header className='flex jcsb aic h-10 py-5'>
          <h1 id='logo'>
            <div className='s-10'></div>
            <a href='/' aria-label='Logotype'>
              <img
                src={logo}
                height={48}
                alt='Codereview'
                style={{ transform: 'translateY(-7px)' }}
              />
            </a>
          </h1>
          <div
            className={opened ? 'burger' : 'burger open'}
            onClick={() => setOpened(!opened)}
          >
            <span className='tt'></span>
            <span className='mm'></span>
            <span className='bb'></span>
          </div>
          <div className={opened ? 'menu active' : 'menu'}>
            <a
              href='#about'
              className='mx-3'
              onClick={() => setOpened(!opened)}
            >
              Про нас
            </a>
            <a href='#plan' className='mx-3' onClick={() => setOpened(!opened)}>
              Оффер
            </a>
            <a href='#team' className='mx-3' onClick={() => setOpened(!opened)}>
              Команда
            </a>
            <a href='#stories' className='mx-3' onClick={() => setOpened(!opened)}>
              Відгуки
            </a>
            <a
              href='#pricing'
              className='mx-3'
              onClick={() => setOpened(!opened)}
            >
              Умови
            </a>
            <a href='#form' className='mx-3' onClick={() => setOpened(!opened)}>
              Контакти
            </a>
            <a href='#faq' className='mx-3' onClick={() => setOpened(!opened)}>
              F.A.Q
            </a>
          </div>
        </header>
      </div>
    </header>
  );
};

export { Nav };
